export const xlarge = '1920px'
export const large = '1440px'
export const medium = '1024px'
export const small = '720px'
export const xsmall = '400px'